import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadPggManifestService } from './services/load-pgg-manifest.service';
import { PggClaimCardComponent } from './components/pgg-claim-card/pgg-claim-card.component';
import { PggJobCardComponent } from './components/pgg-job-card/pgg-job-card.component';
import { PggListJobCardComponent } from './components/pgg-list-job-card/pgg-list-job-card.component';
import { PggListClaimCardComponent } from './components/pgg-list-claim-card/pgg-list-claim-card.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { RouterModule } from '@angular/router';
import { FLXDetailsComponent } from './views/details-view/details-view.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FLXListViewComponent } from './views/list-view/list-view.component';
import { PggService, ClaimService, JobService } from './services';
import { UIElementsModule } from '@flexus/ui-elements';
import { ThemeModule } from '@flexus/ux';
import { PggWorkflowShellComponent } from './base-components/pgg-workflow-shell/pgg-workflow-shell.component';
import { PggFlowComponent } from './base-components/pgg-flow/pgg-flow.component';
import { environment } from '../../../environments/environment';
import { UICompositesModule } from '@flexus/ui-composites';
import { ErrorHandlerModule } from '@flexus/error-handler';
import { ScreensModule } from '@flexus/screens';
import { ActivateStateGuard } from './guards/activate-state.guard';
import { DeactivateStateGuard } from './guards/deactivate-state.guard';
import { SearchBannerModule } from '../../app-shell-features';
import { MsalModule } from '@azure/msal-angular';
import { DynamicLoaderModule } from '@flexus/engine';
import { IdentityModule } from '@flexus/identity';
import { PublicClientApplication } from '@azure/msal-browser';


export function loadConfig(manifest: LoadPggManifestService) {
	return function () {
		return manifest.load();
	};
}

export function tokenGetter() {
	return localStorage.getItem('flexus.web.jwtToken');
}
@NgModule({
	imports: [
		CommonModule,
		...environment.appShellFeatures,
		DynamicLoaderModule,
		ErrorHandlerModule,
		ScreensModule,
		InlineSVGModule,
		NgxPaginationModule,
		RouterModule,
		ThemeModule,
		...environment.plugins['global'],
		UIElementsModule.forRoot({ environment: environment }),
		UICompositesModule.forRoot(environment),
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		}),
		SearchBannerModule
	],
	declarations: [
		PggClaimCardComponent,
		PggListClaimCardComponent,
		PggJobCardComponent,
		PggListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent,
		PggWorkflowShellComponent,
		PggFlowComponent
	],
	exports: [
		...environment.appShellFeatures,
		PggClaimCardComponent,
		PggJobCardComponent,
		PggListClaimCardComponent,
		PggListJobCardComponent,
		FLXDetailsComponent,
		FLXListViewComponent
	],
	providers: [
		ActivateStateGuard,
		DeactivateStateGuard,
		PggService,
		ClaimService,
		JobService,
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadPggManifestService],
			multi: true
		}
	]
})
export class PggManifestModule {}
